<template>
  <div class="modal">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="content">
        <form @submit="setRes">
          <span class="title">Criar conta</span>
          <div class="avatar"
               :style="{background: user === '' ? '' : `url('${avatarUrl(user, { action: 'std,crr=', img_format: '', dance: '', effect: '', frame_num: 30, size: 'l' })}') center -64px`}">
            <div class="white"></div>
          </div>
          <input type="text" name="user" placeholder="Usuário" v-model="user">
          <input type="password" name="pass" placeholder="Senha" v-model="pass">
          <input type="password" name="passr" placeholder="Repita a senha" v-model="passr">
          <span class="code">Sua conta será criada sem validação inicial.</span>
          <button>Criar conta</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>

import { trackEvent } from '@/services/analytics.js'
import { auth, getLogged, avatarUrl } from '@/services/api.js'
import { ref } from 'vue'
import { useStore } from '@/stores/index.js'

const store = useStore()
const emits = defineEmits(['close'])

const user = ref('')
const pass = ref('')
const passr = ref('')

async function setRes(e) {
  e.preventDefault()
  if (pass.value !== passr.value) {
    store.Alert('As senhas não coincidem')
    return
  }
  try {
    await auth.register(user.value, pass.value)
    const logData = await getLogged()
    store.storeUser({ user: { user: logData.nick, id: logData.id, moedas: logData.score ?? 0 }, logged: logData.logged })
    trackEvent('sign_up')
    store.Alert('Conta criada com sucesso!')
    emits('close')
    window.location.reload()
  } catch (e) {
    store.Alert(e.data?.message ?? 'Erro ao criar conta')
  }
}

</script>

<style scoped>

.box {
  width: 300px !important;
  background-color: rgb(236, 241, 235) !important;
  border-radius: 20px !important;
}

.content form {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}


.content form .title {
  width: 100%;
  height: 30px;
  font-size: 20px;
  font-weight: 800;
  text-align: center;
  margin-top: 10px;
  background: -webkit-linear-gradient(#0D93C6, #35B6FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content form .avatar {
  width: 100%;
  height: 140px;
  background: url('@/assets/user.png') no-repeat center 5px;
  margin-top: 30px;
}

.content form .avatar .white {
  width: 100%;
  height: calc(100% + 1px);
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgb(236, 241, 235) 100%);
}

.content form input {
  width: 250px;
  background-color: #fff;
  border-radius: 40px;
  text-align: center;
}

.content form .code {
  font-size: 14px;
  margin-top: 10px;
  font-weight: 500;
}

.content form .code span {
  font-weight: 600;
  color: #2EC044;
}

.content form .code span:hover {
  color: #05e823;
}

.content form button {
  width: 250px;
  height: 46px;
  padding: 0 20px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 46px;
  font-weight: 700;
  border-radius: 40px;
  background: #35B6FF;
  background: linear-gradient(90deg, #0D93C6 0%, #35B6FF 100%);
  margin: 10px 0 0 0;
  transform: none;
}
</style>
